import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { brokerFailedEmail, customerFailedEmail } from '../store/emails/emailActions';
import Header from '../component/Header';
import Footer from '../component/Footer';
import MonekPaymentForm from '../component/MonekPaymentForm';

function UnSuccessful() {
    const { id } = useParams();
    const [formData, setFormData] = useState({});
    const dispatch = useDispatch();
    const [emailSent, setEmailSent] = useState(false);
    const [tryAgain, setTryAgain] = useState(false);

    // 1. Extract URL Parameters on mount
    useEffect(() => {
        const queryString = window.location.href.split("?")[1];
        if (queryString) {
            const params = new URLSearchParams(queryString);
            const data = Object.fromEntries(params.entries());
            setFormData(data);
        }
    }, []);

    // 2. Safely trigger email dispatch ONCE formData is populated
    useEffect(() => {
        if (!emailSent && id && formData.name) {

            // Helper to safely parse string "true"/"false" into actual booleans
            const parseBool = (val) => val === 'true' || val === true;

            const emailData = {
                toEmail: formData.clientEmail || 'sales@thamesbankinsurance.co.uk',
                fullName: formData.name || '',
                productName: formData.insurer || '',
                sessionReference: formData.policyReference || '',
                pReturn: formData.pReturn || '',
                pCode: formData.pCode || formData.postcode || '',
                pRef: formData.policyReference || '',
            };

            const brokerEmailData = {
                toEmail: "sales@thamesbankinsurance.co.uk",
                sessionReference: formData.policyReference || '',
                brokerReference: formData.policyReference || '',
                clientReference: formData.policyReference || '',
                fullName: formData.name || '',
                postCode: formData.pCode || formData.postcode || '',
                coverDate: formData.coverDate || '',
                premium: formData.payment || '0.00',
                insurerName: formData.insurer || '',
                schemeCode: formData.schemeCode || '',
                transactionAmount: formData.transactionamount || '0.00', // Fixed extra quotes issue
                adminCharge: formData.adminCharge || '0.00',
                contactNumber: formData.phone || '',
                alternateContact: "",
                pReturn: formData.pReturn || '',
                pCode: formData.pCode || formData.postcode || '',
                pRef: formData.policyReference || '',
                legalPurchased: parseBool(formData.legalPurchased),
                emergencyPurchased: parseBool(formData.emergencyPurchased),
                keysPurchased: parseBool(formData.keysPurchased),
                gadgetPurchased: parseBool(formData.gadgetPurchased)
            };

            console.log('Sending Customer Failure Payload:', emailData);
            console.log('Sending Broker Failure Payload:', brokerEmailData);

            dispatch(customerFailedEmail(emailData));
            dispatch(brokerFailedEmail(brokerEmailData));
            setEmailSent(true);
        }
    }, [formData, id, emailSent, dispatch]);

    const handleTryAgain = () => {
        setTryAgain(true);
    };

    return (
        <>
            {tryAgain ? (
                <MonekPaymentForm
                    isTest={true}
                    model={{
                        Reference: formData.policyReference,
                        Name: formData?.name,
                        Email: formData?.clientEmail,
                        Address1: formData?.address1,
                        Address2: formData?.address2,
                        Address3: formData?.address3,
                        Postcode: formData?.postcode,
                        TotalToPay: formData?.transactionamount,
                        PaymentReference: formData?.policyReference,
                        Insurer: formData?.insurer,
                        payment: formData?.payment,
                        contact: formData?.phone,
                        schemeCode: formData?.schemeCode,
                        coverDate: formData?.coverDate,
                        pReturn: formData?.pReturn,
                        pCode: formData?.pCode,
                        pRef: formData?.pRef,
                        currentInsurerCharge: formData?.adminCharge,
                        legalPurchased: formData?.legalPurchased,
                        emergencyPurchased: formData?.emergencyPurchased,
                        keysPurchased: formData?.keysPurchased,
                        gadgetPurchased: formData?.gadgetPurchased
                    }}
                />
            ) : null}

            <Header />
            <div className='thankyou-page' style={{ minHeight: 'calc(100vh - 371px)' }}>
                <div className='thankyou-main'>
                    <h1>Payment Unsuccessful</h1>
                    <p>We are sorry but your payment has failed to process.</p>
                    <p>
                        Please contact our customer service department on <b>0344 274 0165</b>, quoting reference to complete your payment.
                    </p>
                    <button type='button' className='btn btn-primary' onClick={handleTryAgain}>
                        Try Again
                    </button>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default UnSuccessful;